import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from "@angular/core";
import { offset } from "@popperjs/core";

declare var ApexCharts: any;

@Component({
  selector: "app-sku-ranking-timeline",
  templateUrl: "./sku-ranking-timeline.component.html",
  styleUrls: ["./sku-ranking-timeline.component.scss"],
})
export class SkuRankingTimelineComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() chartData?: any;
  @Input() selectedDateType?: any;
  @Input() onDownloadDetail!: () => void;

  @ViewChild('valueChart', { static: false }) valueChartElement!: ElementRef;
  @ViewChild('coverageChart', { static: false }) coverageChartElement!: ElementRef;
  @ViewChild('turnChart', { static: false }) turnChartElement!: ElementRef;
  @ViewChild('priceChart', { static: false }) priceChartElement!: ElementRef;

  private valueChartInstance: any;
  private coverageChartInstance: any;
  private turnChartInstance: any;
  private priceChartInstance: any;

  valueRedChartData: any = [];
  valueGreyChartData: any = [];
  coverageRedChartData: any = [];
  coverageGreyChartData: any = [];
  turnRedChartData: any = [];
  turnGreyChartData: any = [];
  priceRedChartData: any = [];
  priceGreyChartData: any = [];
  valueDateChartData: any = [];
  coverageDateChartData: any = [];
  turnDateChartData: any = [];
  priceDateChartData: any = [];
  constructor(private http: HttpClient) { }

  ngOnInit() {
    // this.prepareChartData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chartData']) {
      this.prepareChartData();
      if (this.chartData && this.chartData.length > 0) {
        if (this.valueChartInstance) {
          this.updateChart();
          this.valueChartInstance.destroy();
          this.coverageChartInstance.destroy();
          this.turnChartInstance.destroy();
          this.priceChartInstance.destroy();
          this.createValueChart();
          this.createCoverageChart();
          this.createTurnChart();
          this.createPriceChart();
        } else {
          // Create chart for the first time when we have data
          setTimeout(() => {
            this.createValueChart();
            this.createCoverageChart();
            this.createTurnChart();
            this.createPriceChart();
           }, 500);
        }
      }
    }
  }

  ngAfterViewInit() {
    // Don't create chart here - wait for data
  }

  private prepareChartData() {
    this.valueRedChartData = [];
    this.valueGreyChartData = [];
    this.valueDateChartData = [];
    this.coverageDateChartData = [];
    this.turnDateChartData = [];
    this.priceDateChartData = [];
    this.coverageRedChartData = [];
    this.coverageGreyChartData = [];
    this.turnRedChartData = [];
    this.turnGreyChartData = [];
    this.priceRedChartData = [];
    this.priceGreyChartData = [];

    if (this.chartData) {
      this.chartData.forEach((item: any) => {
        const type = this.selectedDateType?.toLowerCase();
        if (type === 'week') {
          this.valueDateChartData.push(item.YMW);
          this.coverageDateChartData.push(item.YMW);
          this.turnDateChartData.push(item.YMW);
          this.priceDateChartData.push(item.YMW);
        } else if (type === 'month') {
          this.valueDateChartData.push(item.YM);
          this.coverageDateChartData.push(item.YM);
          this.turnDateChartData.push(item.YM);
          this.priceDateChartData.push(item.YM);
        } else if (type === 'quarter') {
          this.valueDateChartData.push(item.YQ);
          this.coverageDateChartData.push(item.YQ);
          this.turnDateChartData.push(item.YQ);
          this.priceDateChartData.push(item.YQ);
        } else if (type === 'half') {
          this.valueDateChartData.push(item.YH);
          this.coverageDateChartData.push(item.YH);
          this.turnDateChartData.push(item.YH);
          this.priceDateChartData.push(item.YH);
        } else if (type === 'year') {
          this.valueDateChartData.push(item.YR);
          this.coverageDateChartData.push(item.YR);
          this.turnDateChartData.push(item.YR);
          this.priceDateChartData.push(item.YR);
        }

        const valueRed = item.ValueRed?.VALUE ?? 0;
        const valueGrey = item.ValueGrey?.VALUE_LY ?? 0;

        this.valueRedChartData.push(valueRed);
        this.valueGreyChartData.push(valueGrey);

        const valueCoverageRed = item.CoverageRed?.COVERAGE ?? 0;
        const valueCoverageGrey = item.CoverageGrey?.COVERAGE_LY ?? 0;

        this.coverageRedChartData.push(valueCoverageRed);
        this.coverageGreyChartData.push(valueCoverageGrey);

        const turnRed = item.TurnRed?.TURL_BOTTLE ?? 0;
        const turnGrey = item.TurnGrey?.TURL_BOTTLE_LY ?? 0;

        this.turnRedChartData.push(turnRed);
        this.turnGreyChartData.push(turnGrey);

        const priceRed = item.PriceRed?.PRICE_BOTTLE ?? 0;
        const priceGrey = item.PriceGrey?.PRICE_BOTTLE_LY ?? 0;

        this.priceRedChartData.push(priceRed);
        this.priceGreyChartData.push(priceGrey);
      });
    }
  }

  private updateChart() {
    if (this.valueChartInstance) {
      this.valueChartInstance.updateSeries([
        {
          name: '',
          data: this.valueRedChartData
        },
        {
          name: '',
          data: this.valueGreyChartData
        }
      ]);
    }

    if (this.coverageChartInstance) {
      this.coverageChartInstance.updateSeries([
        {
          name: '',
          data: this.coverageRedChartData
        },
        {
          name: '',
          data: this.coverageGreyChartData
        }
      ]);
    }

    if (this.turnChartInstance) {
      this.turnChartInstance.updateSeries([
        {
          name: '',
          data: this.turnRedChartData
        },
        {
          name: '',
          data: this.turnGreyChartData
        }
      ]);
    }

    if (this.priceChartInstance) {
      this.priceChartInstance.updateSeries([
        {
          name: '',
          data: this.priceRedChartData
        },
        {
          name: '',
          data: this.priceGreyChartData
        }
      ]);
    }
  }

  private createValueChart() {
    var chartDataRef = this.chartData;
    const tickAmount = 3;
    const maxValue = Math.max(...this.valueRedChartData, ...this.valueGreyChartData);
    let step = Math.ceil(maxValue / tickAmount / 10) * 10;
    const roundedMax = step * tickAmount;

    if (this.valueChartElement) {
      this.valueChartInstance = new ApexCharts(this.valueChartElement.nativeElement, {
        chart: {
          type: 'line',
          height: 220,
          width: Math.max((this.valueDateChartData.length * 32) + 65, 400),
          background: 'transparent',
          toolbar: {
            show: false
          }
        },
        series: [
          {
            name: '',
            data: this.valueRedChartData
          },
          {
            name: '',
            data: this.valueGreyChartData
          }
        ],
        colors: ['#FF6B9D', '#808080'],
        stroke: {
          curve: 'smooth',
          width: 2,
          dashArray: 0
        },
        connectNulls: true,
        xaxis: {
          categories: this.valueDateChartData,
          labels: {
            show: false
          },
          tickPlacement: 'on',
          rangeBarOverlap: false
        },
        yaxis: {
          title: {
            show: false
          },
          min: 0,
          max: roundedMax,
          tickAmount: tickAmount,
          forceNiceScale: false,
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'inherit'
            },
            formatter: function (val: number) {
              return '¥' + val.toFixed(0) + 'M';
            }
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['transparent', 'transparent'],
            opacity: 0.1
          }
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false
            }
          }
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          appendToBody: true,
          followCursor: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
            const valueRed = series[0][dataPointIndex];
            const valueGrey = series[1][dataPointIndex];
            const date = w.globals.categoryLabels[dataPointIndex];

            const currentIndex = dataPointIndex;
            const currentItem = chartDataRef[currentIndex];
            console.log(currentItem)
            const isHoveringRed = seriesIndex === 0;
            const isHoveringGrey = seriesIndex === 1;
            return `
                <div class="custom-tooltip" style="padding: 10px; font-size: 10px; background: white; border: 1px solid #ccc; border-radius: 4px;">
                  <div class="tooltip-header" style="font-weight: bold; margin-bottom: 8px;">Date: ${date}</div>
                  <div class="tooltip-content">
                    ${isHoveringRed ? `
                      <div class="tooltip-item" style="margin-bottom: 4px; background-color: #fff5f7; padding-left: 8px;">
                        <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #FF6B9D; margin-right: 8px; border-radius: 2px;"></span><br/>
                        <span class="tooltip-value">Val.TY (MM JPY): ${currentItem.ValueRed.VALUE ?? " "}</span><br/>
                        <span class="tooltip-value">Val.LY (MM JPY): ${currentItem.ValueRed.VALUE_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Value / % vs. LY (%): ${currentItem.ValueRed.VALUE_VS_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Coverage TY (%): ${currentItem.ValueRed.COVERAGE ?? " "}</span><br/>
                        <span class="tooltip-value">Coverage LY (%): ${currentItem.ValueRed.COVERAGE_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Coverage / Diff. vs. LY (%): ${currentItem.ValueRed.COVERAGE_VS_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Turn (Bottle) TY: ${currentItem.ValueRed.TURL_BOTTLE ?? " "}</span><br/>
                        <span class="tooltip-value">Turn (Bottle) LY: ${currentItem.ValueRed.TURL_BOTTLE_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Turn (Bottle) / Diff. vs. LY: ${currentItem.ValueRed.TURL_BOTTLE_VS_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Price (Bottle) TY (JPY): ${currentItem.ValueRed.PRICE_BOTTLE ?? " "}</span><br/>
                        <span class="tooltip-value">Price (Bottle) LY (JPY): ${currentItem.ValueRed.PRICE_BOTTLE_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Price (Bottle) / Diff. vs. LY (%): ${currentItem.ValueRed.PRICE_BOTTLE_VS_LY ?? " "}</span><br/>
                      </div>
                    ` : ''}
                    ${isHoveringGrey ? `
                    <div class="tooltip-item" style="margin-bottom: 4px; background-color: #f8f8f8; padding-left: 8px;">
                      <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #808080; margin-right: 8px; border-radius: 2px;"></span><br/>
                      <span class="tooltip-value">Val.LY (MM JPY): ${currentItem.ValueGrey.VALUE_LY ?? " "}</span><br/>
                      <span class="tooltip-value">Value / % vs. LY (%): ${currentItem.ValueGrey.VALUE_VS_LY ?? " "}</span><br/>
                    </div>
                    ` : ''}
                  </div>
                </div>
              `;
          }
        },
        markers: {
          size: 4,
          hover: {
            size: 8
          },
          width: 32,
          height: 32
        }
      });

      this.valueChartInstance.render();
    }
  }

  private createCoverageChart() {
    const chartDataRef = this.chartData;
    const tickAmount = 3;
    const maxValue = Math.max(...this.coverageRedChartData, ...this.coverageGreyChartData);
    let step = Math.ceil(maxValue / tickAmount / 10) * 10;
    var roundedMax = step * tickAmount;
    if (maxValue <= 10) {
      roundedMax = 12;
    }
    else {
      roundedMax = step * tickAmount;
    }

    if (this.coverageChartElement) {
      this.coverageChartInstance = new ApexCharts(this.coverageChartElement.nativeElement, {
        chart: {
          type: 'line',
          height: 220,
          width: Math.max((this.coverageDateChartData.length * 32) + 65, 400),
          background: 'transparent',
          toolbar: {
            show: false
          }
        },
        series: [
          {
            name: '',
            data: this.coverageRedChartData
          },
          {
            name: '',
            data: this.coverageGreyChartData
          }
        ],
        colors: ['#FF6B9D', '#808080'],
        stroke: {
          curve: 'smooth',
          width: 2,
          dashArray: 0
        },
        xaxis: {
          categories: this.coverageDateChartData,
          labels: {
            show: false
          },
          tickPlacement: 'on',
          rangeBarOverlap: false
        },
        yaxis: {
          title: {
            show: false
          },
          min: 0,
          max: roundedMax,
          tickAmount: tickAmount,
          forceNiceScale: false,
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'inherit'
            },
            formatter: function (val: number) {
              return val.toFixed(1) + '%';
            }
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['transparent', 'transparent'],
            opacity: 0.1
          }
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false
            }
          }
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          appendToBody: true,
          followCursor: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
            const valueRed = series[0][dataPointIndex];
            const valueGrey = series[1][dataPointIndex];
            const date = w.globals.categoryLabels[dataPointIndex];

            const currentIndex = dataPointIndex;
            const currentItem = chartDataRef[currentIndex];

            const isHoveringRed = seriesIndex === 0;
            const isHoveringGrey = seriesIndex === 1;

            return `
                <div class="custom-tooltip" style="padding: 10px; font-size: 10px; background: white; border: 1px solid #ccc; border-radius: 4px;">
                  <div class="tooltip-header" style="font-weight: bold; margin-bottom: 8px;">Date: ${date}</div>
                  <div class="tooltip-content">
                    ${isHoveringRed ? `
                      <div class="tooltip-item" style="margin-bottom: 4px; background-color: #fff5f7; padding-left: 8px;">
                        <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #FF6B9D; margin-right: 8px; border-radius: 2px;"></span><br/>
                        <span class="tooltip-value">Coverage TY (%): ${currentItem.CoverageRed.COVERAGE ?? " "}</span><br/>
                        <span class="tooltip-value">Coverage / Diff. vs. LY (%): ${currentItem.CoverageRed.COVERAGE_VS_LY ?? " "}</span><br/>
                      </div>
                    ` : ''}
                    ${isHoveringGrey ? `
                    <div class="tooltip-item" style="margin-bottom: 4px; background-color: #f8f8f8; padding-left: 8px;">
                      <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #808080; margin-right: 8px; border-radius: 2px;"></span><br/>
                       <span class="tooltip-value">Coverage LY (%): ${currentItem.CoverageGrey.COVERAGE_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Coverage / Diff. vs. LY (%): ${currentItem.CoverageGrey.COVERAGE_VS_LY ?? " "}</span><br/>
                    </div>
                    ` : ''}
                  </div>
                </div>
              `;
          }
        },
        markers: {
          size: 4,
          hover: {
            size: 8
          },
          width: 32,
          height: 32
        }
      });

      this.coverageChartInstance.render();
    }
  }

  private createTurnChart() {
    const chartDataRef = this.chartData;
    const tickAmount = 3;
    const maxValue = Math.max(...this.turnRedChartData, ...this.turnGreyChartData);
    let step = Math.ceil(maxValue / tickAmount / 10) * 10;
    const roundedMax = step * tickAmount;
    if (this.turnChartElement) {
      this.turnChartInstance = new ApexCharts(this.turnChartElement.nativeElement, {
        chart: {
          type: 'line',
          height: 220,
          width: Math.max((this.turnDateChartData.length * 32) + 65, 400),
          background: 'transparent',
          toolbar: {
            show: false
          }
        },
        series: [
          {
            name: '',
            data: this.turnRedChartData
          },
          {
            name: '',
            data: this.turnGreyChartData
          }
        ],
        colors: ['#FF6B9D', '#808080'],
        stroke: {
          curve: 'smooth',
          width: 2,
          dashArray: 0
        },
        xaxis: {
          categories: this.turnDateChartData,
          labels: {
            show: false
          },
          tickPlacement: 'on',
          rangeBarOverlap: false
        },
        yaxis: {
          title: {
            show: false
          },
          min: 0,
          max: roundedMax,
          tickAmount: tickAmount,
          forceNiceScale: false,
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'inherit'
            },
            formatter: function (val: number) {
              return val.toFixed(0);
            }
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['transparent', 'transparent'],
            opacity: 0.1
          }
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false
            }
          }
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          appendToBody: true,
          followCursor: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
            const valueRed = series[0][dataPointIndex];
            const valueGrey = series[1][dataPointIndex];
            const date = w.globals.categoryLabels[dataPointIndex];

            const isHoveringRed = seriesIndex === 0;
            const isHoveringGrey = seriesIndex === 1;

            const currentIndex = dataPointIndex;
            const currentItem = chartDataRef[currentIndex];
            return `
                <div class="custom-tooltip" style="padding: 10px; font-size: 10px; background: white; border: 1px solid #ccc; border-radius: 4px;">
                  <div class="tooltip-header" style="font-weight: bold; margin-bottom: 8px;">Date: ${date}</div>
                  <div class="tooltip-content">
                    ${isHoveringRed ? `
                      <div class="tooltip-item" style="margin-bottom: 4px; background-color: #fff5f7; padding-left: 8px;">
                        <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #FF6B9D; margin-right: 8px; border-radius: 2px;"></span><br/>
                       <span class="tooltip-value">Turn (Bottle) TY: ${currentItem.TurnRed.TURL_BOTTLE ?? " "}</span><br/>
                        <span class="tooltip-value">Turn (Bottle) / Diff. vs. LY: ${currentItem.TurnRed.TURL_BOTTLE_VS_LY ?? " "}</span><br/>
                      </div>
                    ` : ''}
                    ${isHoveringGrey ? `
                    <div class="tooltip-item" style="margin-bottom: 4px; background-color: #f8f8f8; padding-left: 8px;">
                      <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #808080; margin-right: 8px; border-radius: 2px;"></span><br/>
                     <span class="tooltip-value">Turn (Bottle) LY: ${currentItem.TurnGrey.TURL_BOTTLE_LY ?? " "}</span><br/>
                        <span class="tooltip-value">Turn (Bottle) / Diff. vs. LY: ${currentItem.TurnGrey.TURL_BOTTLE_VS_LY ?? " "}</span><br/>
                    </div>
                    ` : ''}
                  </div>
                </div>
              `;
          }
        },
        markers: {
          size: 4,
          hover: {
            size: 8
          },
          width: 32,
          height: 32
        }
      });

      this.turnChartInstance.render();
    }
  }

  private createPriceChart() {
    const chartDataRef = this.chartData;
    const tickAmount = 3;
    const maxValue = Math.max(...this.priceRedChartData, ...this.priceGreyChartData);
    let step = Math.ceil(maxValue / tickAmount / 10) * 10;
    const roundedMax = step * tickAmount;
    //let offsetY1 = (this.selectedDateType.toLowerCase() == 'week' || this.selectedDateType.toLowerCase() == 'month') ? 10 : 0;
    if (this.priceChartElement) {
      this.priceChartInstance = new ApexCharts(this.priceChartElement.nativeElement, {
        chart: {
          type: 'line',
          height: 220,
          width: Math.max((this.priceDateChartData.length * 32) + 65, 400),
          background: 'transparent',
          toolbar: {
            show: false
          }
        },
        series: [
          {
            name: '',
            data: this.priceRedChartData
          },
          {
            name: '',
            data: this.priceGreyChartData
          }
        ],
        colors: ['#FF6B9D', '#808080'],
        stroke: {
          curve: 'smooth',
          width: 2,
          dashArray: 0
        },
        xaxis: {
          categories: this.priceDateChartData,
          labels: {
            show: true,
            rotate: -90,
            offsetY: 0
          },
          tickPlacement: 'on',
          rangeBarOverlap: false
        },
        yaxis: {
          title: {
            show: false
          },
          min: 0,
          max: roundedMax,
          tickAmount: tickAmount,
          forceNiceScale: false,
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'inherit'
            },
            formatter: function (val: number) {
              return '¥' + val.toFixed(0);
            }
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['transparent', 'transparent'],
            opacity: 0.1
          }
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false
            }
          }
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          appendToBody: true,
          followCursor: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
            const valueRed = series[0][dataPointIndex];
            const valueGrey = series[1][dataPointIndex];
            const date = w.globals.categoryLabels[dataPointIndex];

            const isHoveringRed = seriesIndex === 0;
            const isHoveringGrey = seriesIndex === 1;
            const currentIndex = dataPointIndex;
            const currentItem = chartDataRef[currentIndex];
            return `
                <div class="custom-tooltip" style="padding: 10px; font-size: 10px; background: white; border: 1px solid #ccc; border-radius: 4px;">
                  <div class="tooltip-header" style="font-weight: bold; margin-bottom: 8px;">Date: ${date}</div>
                  <div class="tooltip-content">
                    ${isHoveringRed ? `
                      <div class="tooltip-item" style="margin-bottom: 4px; background-color: #fff5f7; padding-left: 8px;">
                        <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #FF6B9D; margin-right: 8px; border-radius: 2px;"></span><br/>
                        <span class="tooltip-value">Price (Bottle) (JPY) TY: ${currentItem.PriceRed.PRICE_BOTTLE ?? " "}</span><br/>
                        <span class="tooltip-value">Price (Bottle) / Diff. vs. LY (JPY): ${currentItem.PriceRed.PRICE_BOTTLE_VS_LY ?? " "}</span><br/>
                      </div>
                    ` : ''}
                    ${isHoveringGrey ? `
                    <div class="tooltip-item" style="margin-bottom: 4px; background-color: #f8f8f8; padding-left: 8px;">
                      <span class="tooltip-color" style="display: inline-block; width: 12px; height: 12px; background-color: #808080; margin-right: 8px; border-radius: 2px;"></span><br/>
                      <span class="tooltip-value">Price (Bottle) (JPY) LY: ${currentItem.PriceGrey.PRICE_BOTTLE_LY ?? " "}</span><br/>
                      <span class="tooltip-value">Price (Bottle) / Diff. vs. LY (JPY): ${currentItem.PriceGrey.PRICE_BOTTLE_VS_LY ?? " "}</span><br/>
                    </div>
                    ` : ''}
                  </div>
                </div>
              `;
          }
        },
        markers: {
          size: 4,
          hover: {
            size: 8
          },
          width: 32,
          height: 32
        }
      });

      this.priceChartInstance.render();
    }
  }


}
